/**
 * Что умеет клиент для Windows — один список для главной и страницы
 * скачивания, чтобы они не расходились. Только то, что есть в клиенте сейчас;
 * новое умение добавляется сюда в тот же день, когда выходит.
 */
export const APP_FACTS: { title: string; text: string }[] = [
  {
    title: 'Сообщения',
    text: 'фото и альбомы, голосовые, видеокружки, реакции, ответы и пересылка.',
  },
  {
    title: 'Звонки',
    text: 'голос и камера один на один, демонстрация экрана вместе со звуком.',
  },
  {
    title: 'Друзья и статусы',
    text: 'кто в сети, «не беспокоить» и уведомления поверх других окон.',
  },
  {
    title: 'Вход и обновления',
    text: 'вход по QR-коду с телефона, обновления ставятся сами, права администратора не нужны.',
  },
];

/** Честная оговорка: чего в клиенте пока нет. */
export const APP_NOT_YET =
  'Комнаты и совместный просмотр пока живут на сайте — в приложении они появятся следующими. Аккаунт общий.';
